module.exports = __webpack_public_path__ + "media/images/groupRank__eval--wrong@3x-1cc5db8524bf53694639bea6cc801c49.png";